import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';

import type { OrderEvent as OrderEventType } from '@/types/parcel/orders/orderById.interface';
import type { SvgIconTypeMap } from '@mui/material';
import type { OverridableComponent } from '@mui/material/OverridableComponent';

import OrderEvent from './OrderEvent';
import useOrderEventsHistory from './useOrderEventsHistory';

const COLLAPSED_PREVIEW_HEIGHT = 44;
const MIN_EVENTS_TO_ALLOW_COLLAPSE = 2;

interface OrderEventsHistoryProps {
  events: OrderEventType[];
  handleActivityIcon: (status: string) => OverridableComponent<SvgIconTypeMap>;
}

const OrderEventsHistory = (props: OrderEventsHistoryProps) => {
  const hooks = useOrderEventsHistory();

  const canCollapse = props.events.length >= MIN_EVENTS_TO_ALLOW_COLLAPSE;
  const isFullyVisible = hooks.isExpanded || !canCollapse;
  const eventsFromNewestToOldest = [...props.events].sort(
    (firstEvent, secondEvent) =>
      new Date(secondEvent.eventTime).getTime() - new Date(firstEvent.eventTime).getTime(),
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Collapse in={isFullyVisible} collapsedSize={COLLAPSED_PREVIEW_HEIGHT}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {eventsFromNewestToOldest.map((event, index) => (
            <OrderEvent key={index} {...event} Icon={props.handleActivityIcon(event.status)} />
          ))}
        </Box>
      </Collapse>

      {canCollapse && (
        <Button
          onClick={hooks.toggleExpanded}
          endIcon={
            <ExpandMoreIcon
              sx={{
                transform: hooks.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
              }}
            />
          }
          sx={{ alignSelf: 'center', marginTop: '0.5rem' }}
        >
          {hooks.isExpanded ? 'Ver menos' : 'Ver historial completo'}
        </Button>
      )}
    </Box>
  );
};

export default OrderEventsHistory;
